import * as DisclosureConstants from './DisclosureConstants';
import { Disclosure, DisclosureHistory } from '../../../types';
import {
  DisclosureScreenState,
  DisclosureMap,
  DisclosureHistoryMap,
  DisclosureHistoryFilter,
} from './DisclosureTypes';

export default function(
  state = DisclosureConstants.DEFAULT_STATE,
  action: any,
): DisclosureScreenState {
  switch (action.type) {
    case DisclosureConstants.DisclosureActionTypes.LOADING_DISCLOSURES:
      return { ...state, loadStatus: 1 };

    case DisclosureConstants.DisclosureActionTypes.FAILED_DISCLOSURES:
      return { ...state, loadStatus: 0 };

    case DisclosureConstants.DisclosureActionTypes.LOADED_DISCLOSURES:
      let disclosures: DisclosureMap = Object.assign(
        {},
        ...action.payload.map((d: Disclosure) => ({ [d.DisclosureId]: d })),
      );
      let filtered: Array<number> = doSearchFilter(action.payload, state.search);

      let newState: DisclosureScreenState = {
        ...state,
        disclosures: disclosures,
        filtered: filtered,
      };

      return newState;
    //
    case DisclosureConstants.DisclosureActionTypes.LOADED_ACL_DATA:
      return { ...state, loadStatus: 2, admin: action.payload };
    //
    case DisclosureConstants.DisclosureActionTypes.NEW_DISCLOSURE:
      return {
        ...state,
        formState: DisclosureConstants.FORM_STATE.OPEN,
        currentDisclosure: {
          form: { ...DisclosureConstants.BLANK_DISCLOSURE },
          orig: { ...DisclosureConstants.BLANK_DISCLOSURE },
          formMessages: [],
          changed: false,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.EDIT_DISCLOSURE:
      return {
        ...state,
        formState: DisclosureConstants.FORM_STATE.OPEN,
        currentDisclosure: {
          form: { ...action.payload },
          orig: { ...action.payload },
          formMessages: [],
          changed: false,
        },
      };
    //

    case DisclosureConstants.DisclosureActionTypes.SAVE_DISCLOSURE:
    case DisclosureConstants.DisclosureActionTypes.CANCEL_DISCLOSURE_FORM:
      return {
        ...state,
        formState: DisclosureConstants.FORM_STATE.CLOSE,
        currentDisclosure: {
          form: { ...DisclosureConstants.BLANK_DISCLOSURE },
          orig: { ...DisclosureConstants.BLANK_DISCLOSURE },
          formMessages: [],
          changed: false,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.SAVING_DISCLOSURE:
      return {
        ...state,
        formState: DisclosureConstants.FORM_STATE.LOCKED,
        currentDisclosure: {
          ...state.currentDisclosure,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.SAVING_DISCLOSURE_FAILED:
      return {
        ...state,
        formState: DisclosureConstants.FORM_STATE.FAILED_SUBMIT,
        currentDisclosure: {
          ...state.currentDisclosure,
          formMessages: [action.payload.data],
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.RESET_DISCLOSURE_FORM:
      return {
        ...state,
        currentDisclosure: {
          ...state.currentDisclosure,
          form: { ...state.currentDisclosure.orig },
          changed: false,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.SEARCH_STRING_UPDATED:
      return {
        ...state,
        search: action.payload,
        filtered: doSearchFilter(Object.values(state.disclosures), action.payload),
      };
    //
    case DisclosureConstants.DisclosureActionTypes.FORM_FIELDS_UPDATED:
      let form = { ...state.currentDisclosure.form };
      let orig = { ...state.currentDisclosure.orig };

      form[action.payload.name] = action.payload.value;

      return {
        ...state,
        currentDisclosure: {
          ...state.currentDisclosure,
          form: form,
          changed:
            form[action.payload.name] !== orig[action.payload.name] ||
            state.currentDisclosure.changed,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.PAGE_SWITCH:
      return { ...state, pageState: action.payload };
    //

    case DisclosureConstants.DisclosureActionTypes.LOADING_HISTORY_DATA:
      return { ...state, loadStatus: 1 };

    case DisclosureConstants.DisclosureActionTypes.FAILED_HISTORY_DATA:
      return { ...state, loadStatus: 0 };

    case DisclosureConstants.DisclosureActionTypes.LOADED_HISTORY_DATA:
      let histories: DisclosureHistoryMap = Object.assign(
        {},
        ...action.payload.map((d: DisclosureHistory) => ({ [d.DisclosureHistoryId]: d })),
      );
      let filteredHistory: Array<number> = doHistoryFilter(action.payload, state.historyFilters);

      let adminList: Array<string> = [];
      let verticalList: Array<string> = [];
      Object.values(histories).forEach((history: DisclosureHistory) => {
        if (adminList.indexOf(history.CurrentUser.toLowerCase()) < 0) {
          adminList.push(history.CurrentUser.toLowerCase());
        }

        let origVertical = history.OriginalDisclosureVertical + '';
        if (origVertical !== '' && verticalList.indexOf(origVertical.toLowerCase()) < 0) {
          verticalList.push(origVertical.toLowerCase());
        }

        let newVertical = history.NewDisclosureVertical;
        if (newVertical !== '' && verticalList.indexOf(newVertical.toLowerCase()) < 0) {
          verticalList.push(newVertical.toLowerCase());
        }
      });

      return {
        ...state,
        loadStatus: 2,
        history: histories,
        filteredHistory: filteredHistory,
        historyFilterOptions: {
          admin: adminList,
          vertical: verticalList,
        },
      };
    //
    case DisclosureConstants.DisclosureActionTypes.HISTORY_FILTER_UPDATED:
      let historyFilters: DisclosureHistoryFilter = {
        keyword: action.payload.keyword,
        admin: action.payload.admin,
        vertical: action.payload.vertical,
      };
      let updatedfilteredHistory: Array<number> = doHistoryFilter(
        Object.values(state.history),
        historyFilters,
      );

      return {
        ...state,
        filteredHistory: updatedfilteredHistory,
        historyFilters: historyFilters,
      };
    //
    default:
      return state;
  }
}

const doSearchFilter = (list: Array<Disclosure>, find: string): Array<number> => {
  let searchResults: Array<number> = [];

  if (!isEmptyString(find)) {
    let keyword: RegExp = new RegExp(find, 'i');
    Object.values(list).forEach((disclosure: Disclosure) => {
      if (
        disclosure.DisclosureName.search(keyword) >= 0 ||
        disclosure.DisclosureContent.search(keyword) >= 0 ||
        disclosure.DisclosureVertical.search(keyword) >= 0
      ) {
        searchResults.push(disclosure.DisclosureId);
      }
    });
  } else {
    searchResults = list.map((disclosure: Disclosure) => disclosure.DisclosureId);
  }

  return searchResults;
};

const doHistoryFilter = (
  list: Array<DisclosureHistory>,
  filter: DisclosureHistoryFilter,
): Array<number> => {
  let searchResults: Array<number> = [];

  Object.values(list).forEach((history: DisclosureHistory) => {
    let hit: Boolean = false;

    if (
      !isEmptyString(filter.keyword) ||
      !isEmptyString(filter.vertical) ||
      !isEmptyString(filter.admin)
    ) {
      if (!isEmptyString(filter.keyword)) {
        let keyword: RegExp = new RegExp(filter.keyword, 'i');

        hit =
          (history.OriginalDisclosureName + '').search(keyword) >= 0 ||
          (history.OriginalDisclosureContent + '').search(keyword) >= 0 ||
          history.NewDisclosureName.search(keyword) >= 0 ||
          history.NewDisclosureContent.search(keyword) >= 0;
      }

      if (
        !isEmptyString(filter.vertical) &&
        (filter.vertical.toLowerCase() ===
          (history.OriginalDisclosureVertical + '').toLowerCase() ||
          filter.vertical.toLowerCase() === history.NewDisclosureVertical.toLowerCase())
      ) {
        hit = true;
      }

      if (
        !isEmptyString(filter.admin) &&
        filter.admin.toLowerCase() === (history.CurrentUser + '').toLowerCase()
      ) {
        hit = true;
      }

      if (hit) {
        searchResults.push(history.DisclosureHistoryId);
      }
    } else {
      searchResults.push(history.DisclosureHistoryId);
    }
  });

  return searchResults;
};

const isEmptyString = (str: string): boolean => {
  return str === null || str.trim() === '' || str === undefined;
};
